module.exports = __webpack_public_path__ + "img/HistoriaClinicaSinFondo.0481e781.svg";